export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10957.8fe0e076.jpg";